<div class="modal-header">
    <span><i class="fas fa-server"></i><span class="d-none d-sm-inline-block ml-2">Seleziona server</span></span>
    <div class="float-right" *ngIf="timer>0">
        <small class="mr-3">(tra <b class="blink">{{timer}} sec</b> avvio automatico)</small>
        <button type="button" class="btn btn-sm btn-outline-danger px-5" (click)="stopTimer()">STOP</button>
    </div>
</div>
<div class="modal-body pb-0">
    <ul class="list-group">
        <li class="list-group-item p-0" *ngFor="let c of configs">
            <div class="row border-bottom p-2">
                <div class="col-lg-4">
                    <span class="text-primary text-lg">{{c['name']}}</span><br>
                </div>
                <div class="col-lg-8">
                    <ng-container *ngIf="isArray(c['serverUrl'])">
                        <ng-container  *ngFor="let s of c['serverUrl'];let i=index">
                            <input type="radio" #serverUrl name="serverUrl" [(ngModel)]="c['selectedServerUrl']" (change)="select(c)" value="{{s}}" class="pointer mr-2"/>
                            <span [class.font-weight-bold]="serverUrl.checked">{{s}}<div class="ml-2 badge border pointer" *ngIf="serverUrl.checked"><i class="far fa-clock mr-1"></i>automatico</div>
                                <button class="float-right btn btn-outline-success h-100 d-none d-lg-flex align-items-center" (click)="serverUrl.checked=c['selectedServerUrl'];select(c)" *ngIf="serverUrl.checked">Procedi<i class="fa fa-chevron-right ml-1"></i></button>
                            </span><br>
                        </ng-container>
                    </ng-container>
                    <small *ngIf="!isArray(c['serverUrl'])">{{c['serverUrl']}}</small>
                </div>               
            </div>
        </li>
    </ul>
</div>